<template>
  <b-container class="card-container">
    <b-card>
      <b-table-simple bordered>
        <tr>
          <td>Email</td>
          <td>{{profile.email}}</td>
        </tr>
        <tr>
          <td>API key</td>
          <td>{{profile.api_key}}</td>
        </tr>
        <tr>
          <td>Team</td>
          <td>{{profile.team.name}}</td>
        </tr>
        <tr v-if="show_email">
          <td>Default timezone</td>
          <td>UTC +{{profile.default_timezone_offset || 0}}</td>
        </tr>
      </b-table-simple>
      <b-button @click='logout'>Logout</b-button>
    </b-card>

    <div v-if="show_email">
      <h4>Connect email</h4>
      <p>Connect your email account to send emails</p>
      <b-card-group deck>
        <b-card style='max-width: 16em;' title="Gmail" class='text-center'>
          <AuthGmail :profile="profile" />
        </b-card>
        <b-card style='max-width: 16em;' title="Other providers" class='text-center'>
          Coming soon
        </b-card>
      </b-card-group>
    </div>

    <!-- <h4>Danger zone</h4>
    <b-card>
      <b-button variant='danger' @click='delete_user'>Delete account</b-button>
    </b-card> -->
  </b-container>
</template>

<script>

import { db, auth, remote_config } from '@/main.js'
import AuthGmail from '@/components/AuthGmail.vue'


export default {
  metaInfo: {title: 'Settings'},
  props: ['profile'],
  components: {AuthGmail},
  data() {
    let show_email = false
    if (remote_config.getValue('show_sequences').asBoolean() || this.profile.features && this.profile.features.sequences) {
      show_email = true
    }

    return {
      items: [],
      show_email: show_email
    }
  },
  methods: {
    async logout() {
      await auth.signOut()
      this.$router.push({name: 'home'})
    },

    async delete_user() {
      // TODO downgrade billing if have it

    }
  },
}
</script>

<style scoped>

</style>
